// @flow
import React from 'react';
import { isEmpty } from 'lodash';

import { Introduction } from 'Components/frameworks/introduction/Introduction';
import { SiteContainer } from 'Components/frameworks/site-container/SiteContainer';

export type OfferDescriptionLineProps = {
  offer?: {
    color: string,
    description: string,
    timingArgument: string,
  },
  config: {
    common: {
      loadLess: string,
      viewMore: string,
    },
  },
};

export const OfferDescriptionLine = ({ config, offer = {} }: OfferDescriptionLineProps) => {
  if (isEmpty(offer)) {
    return null;
  }

  return (
    <SiteContainer className="Line">
      <Introduction
        color={offer.color}
        text={offer.description}
        title={offer.timingArgument}
        seeLessLabel={config.common.loadLess}
        seeMoreLabel={config.common.viewMore}
      />
    </SiteContainer>
  );
};
